<template>
 <router-view></router-view>
 <NotifyContainer />

</template>

<script>
import NotifyContainer from '@/components/common/NotifyContainer.vue';

export default {
  name: 'App',
  components: {
    NotifyContainer,
  },
  mounted() {
    // Set Velzon layout attributes so CSS selectors match
    const el = document.documentElement;
    el.setAttribute('data-layout', 'vertical');
    el.setAttribute('data-sidebar', 'dark');
    el.setAttribute('data-layout-mode', 'light');
    el.setAttribute('data-topbar', 'light');
    el.setAttribute('data-layout-width', 'fluid');
    el.setAttribute('data-layout-position', 'fixed');
    el.setAttribute('data-sidebar-image', 'none');
    el.setAttribute('data-layout-style', 'default');
    el.setAttribute('data-bs-theme', 'light');
    el.setAttribute('data-preloader', 'disable');

    // Responsive sidebar size based on screen width
    this.updateSidebarSize();
    window.addEventListener('resize', this.updateSidebarSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateSidebarSize);
  },
  methods: {
    updateSidebarSize() {
      const w = window.innerWidth;
      if (w >= 1025) {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      } else if (w >= 768) {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      } else {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
        document.body.classList.remove('vertical-sidebar-enable');
      }
    },
  },
}
</script>

<style>
/* ═══ Mobile Responsive Fixes ═══ */

/* Hide sidebar completely on mobile — only show via hamburger toggle */
@media (max-width: 767.98px) {
  .app-menu,
  .navbar-menu {
    margin-left: -100% !important;
    transition: margin 0.3s ease;
  }

  /* Show sidebar as overlay when toggled */
  .vertical-sidebar-enable .app-menu,
  .vertical-sidebar-enable .navbar-menu {
    margin-left: 0 !important;
    z-index: 1004;
  }

  /* Content takes full width on mobile */
  .main-content {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  #page-topbar {
    left: 0 !important;
    right: 0 !important;
  }

  .footer {
    left: 0 !important;
    right: 0 !important;
  }

  /* Navbar brand box hidden on mobile */
  .navbar-brand-box {
    width: auto !important;
  }

  /* Make tables scrollable */
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Stack filter controls */
  .card-header .d-flex.gap-2 {
    flex-direction: column;
    width: 100%;
  }

  .card-header .d-flex.gap-2 input,
  .card-header .d-flex.gap-2 select {
    width: 100% !important;
  }
}

/* RTL fix: translate sidebar to opposite side on mobile */
@media (max-width: 767.98px) {
  [dir="rtl"] .app-menu,
  [dir="rtl"] .navbar-menu {
    margin-left: 0 !important;
    margin-right: -100% !important;
    transition: margin 0.3s ease;
  }

  [dir="rtl"] .vertical-sidebar-enable .app-menu,
  [dir="rtl"] .vertical-sidebar-enable .navbar-menu,
  .vertical-sidebar-enable[dir="rtl"] .app-menu,
  .vertical-sidebar-enable[dir="rtl"] .navbar-menu {
    margin-right: 0 !important;
  }
}
</style>
